export const placeholder = {
  website: 'https://...',
  email: 'namn@domän.se',
  phone: '+46XXXXXXXXX',
  ssn: 'YYMMDDXXXX',
  name: '2025 - Serie 1 - Sundbybergs TK',
};
